export const API_POST_BASE_LOG_KILN = 'api/log-kiln'
export const API_GET_BASE_LOG_KILNS = 'api/get-log-kilns'
export const API_POST_BASE_BUCKET = 'api/bucket'
export const API_GET_BASE_BUCKETS = 'api/get-buckets'
export const API_POST_BASE_EQUIPMENT = 'api/equipment'
export const API_GET_BASE_EQUIPMENT = 'api/get-equipment'
export const API_GET_PROJECT_BATCHES = 'api/batches'
export const API_GET_ROF_BURNS_BATCH_DATA = 'api/rof-burns/batch-data'
export const API_GET_ROF_BURNS_BATCH_MEDIA = 'api/rof-burns/batch-media'
export const API_GET_ROF_BURNS_ADDITIONAL_BATCH_DATA = 'api/rof-burns/additional-batch-data'
export const API_GET_ROF_BURNS_BATCH_VOLUMES = 'api/rof-burns/batch-volumes'
export const API_GET_ROF_BURNS_BATCH_BULK_DENSITY = 'api/rof-burns/batch-bulk-density'
export const API_GET_ROF_BURNS_BIOCHAR_MASS = 'api/rof-burns/biochar-mass'
export const API_POST_ROF_BURNS_LAB_REPORT_FILE = 'api/rof-burns/lab-report-file-upload'
export const API_GET_ROF_BURNS_LAB_REPORT_FILES = 'api/rof-burns/lab-report-file-uploads'
export const API_GET_DOWNLOAD_BATCH_REPORT = 'api/rof-burns/download-batch-report'
export const API_GET_APPLICATION_TYPE = 'api/rof-burns/application-type'
export const API_GET_ROF_USERS = 'api/user/rof-burns/rof-users'
export const API_ADD_USER_TO_PROJECT = 'api/projects/add-user-project'
export const API_GET_FARM_PROJECTS = 'api/projects/farm'
export const API_PROJECT_INFO = 'api/project-description'
export const API_BIOCHAR_LAB_SAMPLES = 'api/rof-burns/biochar-lab-samples'
export const API_BIOCHAR_LAB_SAMPLES_CONTAMINANTS = 'api/rof-burns/biochar-lab-samples-contaminants'
export const API_IGNITION_FUEL = 'api/rof-burns/ignition-fuel'
export const API_EQUIPMENT_TRANSPORT = 'api/rof-burns/equipment-transport'
